import { apiClient } from './apiClient';

const base = '/api/exotel';

export const exotelService = {
  // Get Exotel configuration
  getConfig: () => apiClient.get(`${base}/config`),

  // Save Exotel configuration
  saveConfig: ({ apiKey, apiToken, subdomain, accountSid, region, webhookUrl }) =>
    apiClient.post(`${base}/config`, {
      api_key: apiKey,
      api_token: apiToken,
      subdomain,
      account_sid: accountSid,
      region: region || null,
      webhook_url: webhookUrl,
    }),

  // Delete Exotel configuration
  deleteConfig: () => apiClient.del(`${base}/config`),

  // Get webhook URLs template
  getWebhook: () => apiClient.get(`${base}/webhook`),

  // Generate webhook URLs with agent API key
  generateWebhook: agentKey => apiClient.post(`${base}/webhook/generate`, { agentKey }),

  // Make outbound call
  makeCall: ({ from_number, caller_id, flow_url }) =>
    apiClient.post(`${base}/call`, {
      from_number,
      caller_id,
      flow_url,
    }),
};

export default exotelService;
